import { Symbol } from "@/Imports";
import Facade from "@/Facade";
import Config from "@/config/Config";

export default class SymbolsFactory {

  constructor (parent) {
    this.pool = []
    this.parent  = parent
  }

  poolIn = (symbol) => {
    const parent = symbol.parent
    if(parent) {
      parent.removeChild (symbol)
    }
    symbol.alpha = 1
    symbol.visible = false
    this.pool.push(symbol)
  }

  poolOut = (index, container = null) => {
    let symbol
    const parent = container ? container : this.parent
    if (this.pool.length > 0) {
      symbol = this.pool.pop()
      symbol.changeTextureByIndex(index)
      //symbol.showMultiplier(mult)
      parent.addChild(symbol)
      symbol.alpha = 1
      symbol.visible = true
      return symbol
    } else {
      symbol = this.createSymbol(index)
     // symbol.initImageMultiplier(Config.multiplier.list, Config.multiplier.position)
      //symbol.showMultiplier(mult)
      parent.addChild(symbol)
      symbol.alpha = 1
      symbol.visible = true
      return symbol
    }
  }

  createSymbol(index) {
    return new Symbol(index)
  }

}
